/*
  Returns current page scroll amount
*/

export function getCurrentScroll() {
  return window.pageYOffset || document.documentElement.scrollTop;
}